import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Box, Typography } from '@mui/material'

import Autocomplete from '../../../../ui/components/autocomplete'

import useTranslations from '../../../../i18n/useTranslations'

import useStyles from './styles'

const propTypes = {
  imputationCenters: PropTypes.arrayOf(PropTypes.object),
  selectedImputationCenter: PropTypes.object,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
}

const Sender = ({
  imputationCenters,
  selectedImputationCenter,
  onBlur,
  onChange,
}) => {
  const classes = useStyles()
  const formatMessage = useTranslations()

  return (
    <Box component="section" className={classes.section}>
      <Typography
        variant="h2"
        className={clsx('secondaryTitle', 'decorator', classes.title)}
      >
        {formatMessage('shipping-send-form:title:center')}
      </Typography>
      <Autocomplete
        name="imputationCenter"
        options={imputationCenters}
        isOptionEqualToValue={(option, value) => {
          return option.id === value.id
        }}
        getOptionLabel={option => {
          return option ? `${option.id} | ${option.name}` : ''
        }}
        noOptionsText={formatMessage('message:no-results')}
        inputProps={{
          name: 'imputationCenter',
          placeholder: formatMessage('placeholder:client'),
          onBlur,
          value: selectedImputationCenter,
          helperText: '',
          className: classes.inputCode,
        }}
        value={selectedImputationCenter}
        onChange={(_, value) => {
          if (value) {
            onChange({ target: { name: 'imputationCenter', value } })
          }
        }}
        autoHighlight
        getOptionDisabled={(option) => option.status !== "ACTIVE"}
      />
    </Box>
  )
}

Sender.propTypes = propTypes

export default Sender
